module.exports = __webpack_public_path__ + "img/head8.9c54f2d8.png";